import { Mutations as M } from 'vuex-smart-module'
import { BaseApiParams as BP } from '@/typings/common'
import { State } from './State'
import { CrudPathData } from './typings/typings'
import set from 'lodash/set'


export abstract class Mutations<T, TT, S extends State<T, TT> = State<T, TT>> extends M<S> {
  public setDataByPath(payload: CrudPathData<T>): void {
    const { path, data } = payload
    set(this.state, path, data)
  }

  public setList(payload?: TT[]): void {
    this.state.list = payload || []
  }

  public setListMeta(payload: BP): void {
    this.state.listMeta = payload
  }

  public setOne(payload?: T): void {
    this.state.single = payload
  }

  public setFilters(payload: BP = {}): void {
    this.state.filters = { ...payload }
  }

  public logout(): void {
    const { state } = this

    state.list = void 0
    state.listMeta = {}
    state.filters = {}
    state.list = void 0
  }
}
